import $ from 'jquery';
window.jQuery = $;

import {heroUnit} from './layout-builder/templates/hero-unit';

$(function() {
    
    $(document).mouseup(function (e){

        if (e.target === $('.hamburger') || $('.hamburger').has(e.target).length) {
            $('.hamburger').hasClass('expanded') ? $('.hamburger').removeClass('expanded') : $('.hamburger').addClass('expanded');
            $('.site-header .nav-wrapper').hasClass('is-open') ? $('.site-header .nav-wrapper').removeClass('is-open') : $('.site-header .nav-wrapper').addClass('is-open');
            $('html').hasClass('no-scroll') ? $('html').removeClass('no-scroll') : $('html').addClass('no-scroll');
        }

        var offCanvas = $(".site-header .nav-wrapper");
        if (!offCanvas.is(e.target) 
            && offCanvas.has(e.target).length === 0 
            && e.target !== $('.hamburger') 
            && !$('.hamburger').has(e.target).length) {
                offCanvas.removeClass('is-open');
                $('.hamburger').removeClass('expanded');
                $('.site-header .nav-wrapper').removeClass('is-open');
                $('html').removeClass('no-scroll');

        }
    });

    $('.menu-item.menu-item-has-children > a').each((i, link) => {
        $(link).on('click', e => {
            e.preventDefault();
        })
    })

    /* Sticky header */
    window.onscroll = function() { stickyHeader() };
    const header = document.querySelector('.site-header');
    var sticky = header.offsetTop;

    function stickyHeader() {
        if (window.pageYOffset/4 > sticky) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }

    heroUnit();

    $(document).on('click', '.js-scroll-to-content', function (event) {
        event.preventDefault();
    
        $('html, body').animate({
            scrollTop: $('.hero-unit').outerHeight()
        }, 50);
    });


    // Add no-hero class to body if no hero unit on the page
    if(!document.querySelector('.hero-unit')) {
        document.querySelector('body').classList.add('no-hero');
    }
});
